var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { insertAfter } from '../helpers/elements';
var Actions = /** @class */ (function () {
    function Actions(EditCell) {
        this.EditCell = EditCell;
        this.Cell = this.EditCell.Cell;
        this.reset();
    }
    /*
    Remove the actions from the cell
     */
    Actions.prototype.reset = function () {
        var container = this.Cell.el.querySelector('.acp-ie-controls__items');
        if (container) {
            container.remove();
        }
    };
    Actions.prototype.isRevisioningEnabled = function () {
        return !this.Cell.getSettings().editable.hasOwnProperty('disable_revisioning');
    };
    Actions.prototype.render = function () {
        var container = Actions.createContainer();
        var valueCell = this.Cell.el.querySelector('.acp-ie-value');
        this.Cell.el.appendChild(container);
        if (valueCell) {
            insertAfter(container, valueCell);
        }
        Actions.appendButton(this.renderEdit(), container);
        if (this.isRevisioningEnabled()) {
            Actions.appendButton(this.renderUndo(), container);
            Actions.appendButton(this.renderRedo(), container);
        }
        Actions.appendButton(this.renderClear(), container);
    };
    Actions.createContainer = function () {
        var container = document.createElement('div');
        container.classList.add('acp-ie-controls');
        return container;
    };
    Actions.appendButton = function (button, element) {
        if (button) {
            element.appendChild(button);
        }
    };
    Actions.prototype.renderEdit = function () {
        var _this = this;
        var el = Actions.createButtonElement(ACP_Editing.i18n.edit, '-edit');
        el.insertAdjacentHTML('beforeEnd', "<span class=\"dashicons dashicons-edit\"></span>");
        el.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.EditCell.openEditable();
        });
        return el;
    };
    Actions.prototype.renderUndo = function () {
        var _this = this;
        var storage = this.Cell.dataStorage;
        if (storage.current_revision === 0) {
            return false;
        }
        var el = Actions.createButtonElement(ACP_Editing.i18n.undo, '-undo');
        el.insertAdjacentHTML('beforeEnd', "<span class=\"dashicons dashicons-undo\"></span>");
        el.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.EditCell.undo();
        });
        return el;
    };
    Actions.prototype.renderRedo = function () {
        var _this = this;
        var storage = this.Cell.dataStorage;
        if (storage.current_revision >= (storage.revisions.length - 1)) {
            return;
        }
        var el = Actions.createButtonElement(ACP_Editing.i18n.redo, '-redo');
        el.insertAdjacentHTML('beforeEnd', "<span class=\"dashicons dashicons-redo\"></span>");
        el.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.EditCell.redo();
        });
        return el;
    };
    Actions.prototype.renderClear = function () {
        var _this = this;
        var storage = this.Cell.dataStorage;
        if (!this.Cell.getSettings().editable.clear_button) {
            return;
        }
        if (!storage.getValue()) {
            return;
        }
        if (typeof storage.getValue() === 'object' && storage.getValue().length === 0) {
            return;
        }
        var el = Actions.createButtonElement(ACP_Editing.i18n.delete, '-clear');
        el.insertAdjacentHTML('beforeEnd', "<span class=\"dashicons dashicons-no-alt\"></span>");
        el.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.EditCell.clear();
        });
        return el;
    };
    Actions.createButtonElement = function (title, className) {
        var button = document.createElement('span');
        button.classList.add('acp-ie-controls__item');
        button.classList.add(className);
        button.setAttribute('title', title);
        return button;
    };
    return Actions;
}());
export { Actions };
var MediaActions = /** @class */ (function (_super) {
    __extends(MediaActions, _super);
    function MediaActions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaActions.prototype.render = function () {
        this.wrapImages();
    };
    MediaActions.prototype.wrapImages = function () {
        var images = this.Cell.el.querySelectorAll('.ac-image');
        var globalcontrols = this.Cell.el.querySelector('.acp-ie-controls');
        if (!images) {
            return;
        }
        images.forEach(function (image) {
            var id = image.dataset.mediaId;
            var wrapper = document.createElement('div');
            var controls = document.createElement('div');
            controls.classList.add('acp-ie-image-controls');
            wrapper.dataset.mediaId = id;
            wrapper.classList.add('acp-ie-image-item');
            image.parentNode.insertBefore(wrapper, image);
            wrapper.appendChild(image);
            wrapper.appendChild(controls);
        });
        if (this.Cell.getSettings().editable.multiple) {
            this.addSingleImageDelete();
            globalcontrols.classList.add('-multiple');
        }
        else {
            this.moveActions();
            globalcontrols.classList.add('-single');
        }
    };
    MediaActions.prototype.addSingleImageDelete = function () {
        var _this = this;
        var images = this.Cell.el.querySelectorAll('.acp-ie-image-item');
        if (!images) {
            return;
        }
        images.forEach(function (image) {
            var controls = image.querySelector('.acp-ie-image-controls');
            var btn_remove = _this.renderDelete();
            controls.append(btn_remove);
        });
    };
    MediaActions.prototype.moveActions = function () {
        var controls = this.Cell.el.querySelector('.acp-ie-controls');
        var imageControls = this.Cell.el.querySelector('.acp-ie-image-controls');
        if (!controls || !imageControls) {
            return;
        }
        controls.querySelectorAll('.acp-ie-controls__item').forEach(function (control) {
            imageControls.append(control);
        });
        imageControls.classList.add('-single');
    };
    MediaActions.prototype.renderDelete = function () {
        var _this = this;
        var self = this;
        var btn_remove = MediaActions.createButtonElement(ACP_Editing.i18n.delete, '-delete');
        btn_remove.insertAdjacentHTML('beforeend', "<span class=\"dashicons dashicons-no-alt\"></span>");
        btn_remove.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var item = e.target.closest('.acp-ie-image-item');
            var dataStorage = self.Cell.dataStorage;
            var value = dataStorage.getValue();
            if (Array.isArray(value)) {
                value = value.filter(function (e) { return parseInt(e) !== parseInt(item.dataset.mediaId); });
            }
            else {
                value = '';
            }
            _this.EditCell.saveValue(value);
        });
        return btn_remove;
    };
    MediaActions.prototype.renderDownload = function () {
        var _this = this;
        var el = Actions.createButtonElement(ACP_Editing.i18n.download, '-download');
        el.insertAdjacentHTML('beforeEnd', "<span class=\"dashicons dashicons-migrate\"></span>");
        el.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.EditCell.redo();
        });
        return el;
    };
    return MediaActions;
}(Actions));
export { MediaActions };
